import React from 'react';
import {  BsInstagram } from 'react-icons/bs';
import { BsLinkedin } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    
    <div>
      <a href="https://www.linkedin.com/in/isaac-henderson/" target="_blank" rel="noopener noreferrer">
        <BsLinkedin />
      </a>
    </div>
    <div>
      <a href="https://www.instagram.com/theisaachendo/" target="_blank" rel="noopener noreferrer">
        <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;
